import React from 'react';

const MapPlaceholder = () => {
  return (
    <p>
      <noscript>You need to enable JavaScript to see this map.</noscript>
    </p>
  );
};

export default MapPlaceholder;
